export default {
  methods: {
    usedArr: inputArr => Array.isArray(inputArr) && inputArr.length && inputArr
  }
}

